"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var shadowColor = function shadowColor(props) {
  var degrees = props.right ? '315deg' : '45deg';
  var color = (0, _pclnDesignSystem.getPaletteColor)('dark')(props);
  return "\n        background:\n            linear-gradient(".concat(degrees, ", transparent 50%, rgba(0, 0, 0, 0.5) 50%),\n            linear-gradient(").concat(degrees, ", transparent 50%, ").concat(color, " 50%);\n    ");
};

var StyledFlex = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-9q7kr3-0"
})(["float:", ";"], function (props) {
  return props.right ? 'right' : 'left';
});
var FlagShadow = (0, _styledComponents["default"])(_pclnDesignSystem.Box).withConfig({
  componentId: "sc-9q7kr3-1"
})(["width:8px;height:8px;align-self:flex-end;position:absolute;bottom:0;", ";"], shadowColor);
var FlagSlice = (0, _styledComponents["default"])(_pclnDesignSystem.Box).withConfig({
  componentId: "sc-9q7kr3-2"
})(["flex:none;width:18px;background-color:", ";border-radius:", ";transform:skew(", ");position:relative;z-index:1;"], (0, _pclnDesignSystem.getPaletteColor)('base'), (0, _themeGet.themeGet)('radius'), function (props) {
  return props.right ? '14deg' : '-14deg';
});

var flexAuto = function flexAuto(props) {
  return props.flexAuto && {
    flex: '1 1 auto'
  };
};

var FlagBody = (0, _styledComponents["default"])(_pclnDesignSystem.Box).withConfig({
  componentId: "sc-9q7kr3-3"
})(["font-size:", "px;", " ", ";z-index:2;"], (0, _themeGet.themeGet)('fontSizes.0'), flexAuto, _pclnDesignSystem.color);
var RelativeHide = (0, _styledComponents["default"])(_pclnDesignSystem.Hide).withConfig({
  componentId: "sc-9q7kr3-4"
})(["position:relative;"]);

var Flag = function Flag(_ref) {
  var color = _ref.color,
      width = _ref.width,
      right = _ref.right,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "width", "right", "children"]);

  return right ? renderRightAligned(color, width, children, props) : renderLeftAligned(color, width, children, props);
};

var renderLeftAligned = function renderLeftAligned(color, width, children, props) {
  return _react["default"].createElement(StyledFlex, _extends({}, props, {
    width: width,
    ml: -2
  }), _react["default"].createElement(RelativeHide, null, _react["default"].createElement(FlagShadow, {
    mr: -2,
    mb: -2,
    color: color
  })), _react["default"].createElement(FlagBody, {
    flexAuto: Boolean(width),
    align: "left",
    color: color,
    py: [1, 2],
    pl: 3,
    pr: 1
  }, children), _react["default"].createElement(FlagSlice, {
    color: color,
    ml: -2
  }));
};

var renderRightAligned = function renderRightAligned(color, width, children, props) {
  return _react["default"].createElement(StyledFlex, _extends({}, props, {
    width: width,
    mr: -2,
    right: true
  }), _react["default"].createElement(FlagSlice, {
    color: color,
    mr: -2,
    right: true
  }), _react["default"].createElement(FlagBody, {
    flexAuto: Boolean(width),
    align: "right",
    color: color,
    py: [1, 2],
    pl: 1,
    pr: 3
  }, children), _react["default"].createElement(RelativeHide, null, _react["default"].createElement(FlagShadow, {
    ml: -2,
    mb: -2,
    color: color,
    right: true
  })));
};

Flag.propTypes = _objectSpread({}, _pclnDesignSystem.color.propTypes, {
  right: _propTypes["default"].bool
});
Flag.defaultProps = {
  color: 'secondary',
  right: false
};
Flag.displayName = 'Flag';
var _default = Flag;
exports["default"] = _default;